import { FC, SVGProps } from "react";

const FlightIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentcolor" {...props}>
      <path
        d="M5.83333 23.3333V20.4167L9.33333 17.9667V13.7667L0 17.5V14L9.33333 7.46667V2.33333C9.33333 1.69167 9.56181 1.14236 10.0188 0.685417C10.4757 0.228472 11.025 0 11.6667 0C12.3083 0 12.8576 0.228472 13.3146 0.685417C13.7715 1.14236 14 1.69167 14 2.33333V7.46667L23.3333 14V17.5L14 13.7667V17.9667L17.5 20.4167V23.3333L11.6667 21.5833L5.83333 23.3333Z"
      />
    </svg>
  );
};

export default FlightIcon;
